module.exports = "/_next/static/media/2ec575ceb443132d3562a9f00d23f8ae.png";